import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

// Define the API
const BrandApi = createApi({
  reducerPath: "BrandApi", // Unique key for the reducer
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getAllBrand: builder.query({
      query: () => "accounts/brand",
      transformResponse: (response) => response?.data, // Extracting the data
    }),

    getSingleBrand: builder.query({
      query: (id) => `accounts/brand/${id}`,
      transformResponse: (response) => response.data, // Extracting the data
    }),

    addBrand: builder.mutation({
      query: (newBrand) => ({
        url: "accounts/brand",
        method: "POST",
        body: newBrand, // Sending the new brand data
      }),
      onQueryStarted: async (newBrand, { dispatch, queryFulfilled }) => {
        try {
          const { data: addedBrand } = await queryFulfilled;
          dispatch(
            BrandApi.util.updateQueryData("getAllBrand", undefined, (draft) => {
              draft.unshift(addedBrand.data); // Add the new brand to the list
            })
          );
        } catch (error) {
          console.error("Failed to add brand:", error);
        }
      },
    }),

    editBrand: builder.mutation({
      query: ({ id, ...updatedBrand }) => ({
        url: `accounts/brand/${id}`,
        method: "PUT",
        body: updatedBrand, // Sending the updated brand data
      }),
      onQueryStarted: async (
        { id, ...updatedBrand },
        { dispatch, queryFulfilled }
      ) => {
        try {
          const { data: updatedBrandData } = await queryFulfilled;
          dispatch(
            BrandApi.util.updateQueryData("getAllBrand", undefined, (draft) => {
              const brandIndex = draft.findIndex((brand) => brand._id === id);
              if (brandIndex !== -1) {
                draft[brandIndex] = updatedBrandData.data; // Update the brand data
              }
            })
          );
        } catch (error) {
          console.error("Failed to edit brand:", error);
        }
      },
    }),

    deleteBrand: builder.mutation({
      query: (id) => ({
        url: `accounts/brand/${id}`,
        method: "DELETE",
      }),
      onQueryStarted: async (id, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            BrandApi.util.updateQueryData("getAllBrand", undefined, (draft) => {
              return draft.filter((brand) => brand.id !== id); // Remove the deleted brand from the list
            })
          );
        } catch (error) {
          console.error("Failed to delete brand:", error);
        }
      },
    }),
  }),
});

// Export hooks generated by the API
export const {
  useGetAllBrandQuery,
  useGetSingleBrandQuery,
  useAddBrandMutation,
  useEditBrandMutation,
  useDeleteBrandMutation,
} = BrandApi;

export default BrandApi;
